import { CircularProgress, Modal, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import CustomButton from "../components/CustomButton";
import DeleteUserAccount from "../components/DeleteUserAccount";
import ResetPassword from "../components/ResetPassword";
import { resendVerificationLink } from "../features/User/UserSlice";
import toast from "react-hot-toast";
import "../styles/pages/dashboard.scss";
import { privateNavigationLinks } from "../utils/navigationLinks";
import NavbarScroller from "../components/Navbar";

const Dashboard: React.FC = () => {
  const {
    username,
    email,
    name,
    isEmailVerified,
    isSuccess,
    successType,
    isFetching,
  } = useSelector((state: RootState) => state.user);

  const [data, setData] = useState({ username: "", email: "", name: "" });
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();

  const verificationLinkHandler = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    // //console.log("verification link is being handled");
    dispatch(resendVerificationLink());
    setOpen(true);
  };

  useEffect(() => {
    setData({ username, email, name });
  }, [email, username, name]);

  useEffect(() => {
    if (isSuccess && successType === "resendVerificationLink") {
      toast.success("Email verification link resent. Please check your email.");
    }
  }, [isSuccess]);

  useEffect(() => {
    if (!isFetching) {
      setOpen(false);
    }
  }, [isFetching]);

  return (
    <div>
      <NavbarScroller links={privateNavigationLinks.links} />
      <div className="account-details">
        <p id="header">Account Details</p>
        <div className="username">
          <p>
            <div id="subheader">Username</div>
            <br />
            {username}
          </p>
        </div>
        <br />
        <div className="name">
          <p>
            <div id="subheader">Name</div>
            <br />
            {name}
          </p>
        </div>
        <br />
        <div className="email">
          <p>
            <div id="subheader">Email</div>
            <div className="email-div">
              <p>{email}</p>
              {!isEmailVerified ? (
                <Tooltip title="Email not verified">
                  <div id="verification-area">
                    <div className="email-verification"></div>
                  </div>
                </Tooltip>
              ) : (
                <></>
              )}
            </div>
            {!isEmailVerified ? (
              <CustomButton
                displayText="Resend Verification Email"
                className="delete-user-button"
                style={{
                  color: "black",
                  border: "2px solid black",
                  width: "15rem",
                  boxShadow: "5px 5px 0",
                  marginTop: "1.2rem",
                }}
                onClick={(e) => verificationLinkHandler(e)}
              />
            ) : (
              <></>
            )}
          </p>
        </div>
        <br />
        <div className="reset-password">
          <ResetPassword />
        </div>
        <div className="delete-user-account">
          <DeleteUserAccount />
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="delete-habit-modal"
        >
          <div
            className="loading-icon"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress style={{ color: "white" }} />
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default Dashboard;
